<template>
    <div class="relative" @mouseenter="openDropdown" @mouseleave="closeDropdown">
        <button ref="dropdownButton"
                class="group flex items-center justify-between w-full py-2 px-3 font-semibold border-b border-gray-100 md:w-auto hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-indigo-500 md:p-0 dark:text-white md:dark:hover:text-indigo-500 dark:hover:bg-gray-700 dark:hover:text-indigo-500 md:dark:hover:bg-transparent dark:border-gray-700">
            {{ btnText }}
            <IconChevronDown :rotate="isOpen"
                             class="w-4 h-4 text-xs ms-3 transition-transform menu-chevron text-black dark:text-white group-hover:text-indigo-500"/>
        </button>
        <div ref="dropdownMenu" v-if="isOpen">
            <div class="dropdown-menu absolute pt-5 z-10 w-auto">
                <div
                    class="p-4 text-sm bg-gray-700 border border-gray-700 rounded-lg shadow-md dark:bg-white dark:border-gray-100">
                    <div class="flex justify-between gap-5">
                        <div v-for="submenu in menuItem" :key="submenu.title"
                             class="border-2 border-gray-300 border-dashed rounded-[1rem]">
                            <div class="p-4 px-8 pb-0 text-white md:pb-4 dark:text-white">
                                <div v-if="menuItem.submenu && menuItem.submenu.length < 1">
                                    <template v-if="submenu.route_name">
                                        <Link :href="route(submenu.route_name, submenu.route_params ?? {})"
                                              :key="submenu.route_name"
                                              class="text-sm lg:text-base text-white dark:text-black hover:text-indigo-400 dark:hover:text-indigo-600 transition font-bold mb-3 text-nowrap">
                                            {{ submenu.title }}
                                        </Link>
                                    </template>
                                    <template v-else>
                                        <div v-if="submenu.title"
                                             class="text-sm lg:text-base text-white dark:text-black cursor-default font-bold mb-3 text-nowrap">
                                            {{ submenu.title }}
                                        </div>
                                    </template>
                                </div>
                                <div class="flex justify-between gap-10 text-black">
                                    <div v-for="subSubmenu in submenu.submenu">
                                        <template v-if="subSubmenu.route_name">
                                            <Link :href="route(subSubmenu.route_name, subSubmenu.route_params ?? {})"
                                                  :key="subSubmenu.route_name"
                                                  class="text-sm lg:text-base text-white dark:text-black hover:text-indigo-400 dark:hover:text-indigo-600 transition font-bold text-nowrap">
                                                {{ subSubmenu.title }}
                                            </Link>
                                        </template>
                                        <template v-else>
                                            <div v-if="subSubmenu.title"
                                                 class="text-sm lg:text-base text-white dark:text-black cursor-default font-bold text-nowrap">
                                                {{ subSubmenu.title }}
                                            </div>
                                        </template>
                                        <div class="flex">
                                            <ul class="max-w-md space-y-2 list-none list-inside mt-2" v-if="submenu">
                                                <li v-for="subSubmenu in subSubmenu.submenu">
                                                    <Link
                                                        :href="route(subSubmenu.route_name, subSubmenu.route_params ?? {})"
                                                        :key="subSubmenu.route_name"
                                                        class="text-md text-white dark:text-black hover:text-indigo-400 dark:hover:text-indigo-600 font-medium transition text-nowrap">
                                                        {{ subSubmenu.title }}
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";
import {Link} from "@inertiajs/vue3";
import {Inertia} from "@inertiajs/inertia";

export default {
    name: "TopBarMenuBigDropdown",
    components: {Link, IconChevronDown},
    props: {
        btnText: {
            type: String,
            default: "Кнопка"
        },
        menuItem: {}
    },
    data() {
        return {
            isOpen: false
        };
    },
    methods: {
        openDropdown() {
            this.isOpen = true;
        },
        closeDropdown() {
            this.isOpen = false;
        }
    },
    mounted() {
        Inertia.on("navigate", (event) => {
            this.closeDropdown()
        });
    }
};
</script>

<style scoped lang="scss">
.dropdown-menu {
    left: 50%;
    transform: translateX(-50%);
    min-width: 12rem;
}
</style>
